<template>
  <form class="panel event-form" @submit.prevent="$emit('submit')">
    <label>
      Название
      <input v-model="name" type="text" class="input" required />
    </label>

    <label>
      Дата поездки
      <input v-model="tripDate" type="date" class="input" required />
    </label>

    <TrackCompletionPicker
      v-model="trackCompletionId"
      :current-completion-id="currentCompletionId"
      @selected="onCompletionSelected"
    />

    <label>
      Текст
      <RichTextEditor v-model="body" :upload-image="uploadTripBodyImage" />
    </label>

    <TripPhotosField
      v-model:pending-photos="pendingPhotos"
      :existing-photos="existingPhotos"
      :add-label="photosAddLabel"
    />

    <CompanionPicker v-model="companions" />

    <label class="checkbox-label">
      <input v-model="isPublic" type="checkbox" />
      Публичная поездка
    </label>

    <label class="checkbox-label">
      <input v-model="allowComments" type="checkbox" />
      Разрешить комментарии
    </label>

    <p v-if="error" class="error-message">{{ error }}</p>

    <div class="btn-row">
      <button class="btn" type="submit" :disabled="submitting">
        {{ submitting ? 'Сохранение...' : 'Сохранить' }}
      </button>
      <router-link class="btn btn-secondary" :to="cancelTo">Отмена</router-link>
    </div>
  </form>
</template>

<script setup>
import CompanionPicker from './CompanionPicker.vue'
import RichTextEditor from './RichTextEditor.vue'
import TrackCompletionPicker from './TrackCompletionPicker.vue'
import TripPhotosField from './TripPhotosField.vue'
import { uploadTripBodyImage } from '../api/trips'

const props = defineProps({
  autofillTripDateFromCompletion: {
    type: Boolean,
    default: false,
  },
  currentCompletionId: {
    type: String,
    default: '',
  },
  existingPhotos: {
    type: Array,
    default: () => [],
  },
  photosAddLabel: {
    type: String,
    default: 'Фотографии поездки',
  },
  error: {
    type: String,
    default: '',
  },
  submitting: {
    type: Boolean,
    default: false,
  },
  cancelTo: {
    type: Object,
    required: true,
  },
})

defineEmits(['submit'])

const name = defineModel('name', { type: String, default: '' })
const tripDate = defineModel('tripDate', { type: String, default: '' })
const trackCompletionId = defineModel('trackCompletionId', { type: String, default: '' })
const body = defineModel('body', { type: String, default: '' })
const pendingPhotos = defineModel('pendingPhotos', { type: Array, default: () => [] })
const companions = defineModel('companions', { type: Array, default: () => [] })
const isPublic = defineModel('isPublic', { type: Boolean, default: false })
const allowComments = defineModel('allowComments', { type: Boolean, default: false })

function onCompletionSelected(completion) {
  if (!props.autofillTripDateFromCompletion || !completion?.completed_at) return
  tripDate.value = String(completion.completed_at).slice(0, 10)
}
</script>

<style scoped>
.event-form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.event-form label {
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
  font-weight: 600;
}

.event-form :deep(.input),
.event-form input[type='text'],
.event-form input[type='date'],
.event-form select.input {
  border: 1px solid #cbd5e1;
  border-radius: 0.5rem;
  padding: 0.625rem 0.75rem;
}

.checkbox-label {
  flex-direction: row !important;
  align-items: center;
  font-weight: 500 !important;
}
</style>
